import React, { Fragment } from 'react';
import AccountSetupStatus from './components/AccountSetupStatus/AccountSetupStatus';
import AuditLog from './components/AuditLog/AuditLog';
import AutomatedOnboarding from './components/AutomatedOnboarding/AutomatedOnboarding';
import { CopyVersion } from './components/CopyVersion/CopyVersion';
import EmptyEditor from './components/EmptyEditor/EmptyEditor';
import ForecastEditor from './components/ForecastEditor/ForecastEditor';
import GLSettings from './components/GLSettings/GLSettings';
import GLWriteBack from './components/GLWriteBack/GLWriteBack';
import Jobs from './components/Jobs/Jobs';
import Onboard from './components/Onboard/Onboard';
import { ReleaseNotes } from './components/ReleaseNotes/ReleaseNotes';
import { VersionLocking } from './components/VersionLocking/VersionLocking';
import WebhookAcctNotification from './components/WebhookAcctNotification/WebhookAcctNotification';
import WebhookLogQueue from './components/WebhookLogQueue/WebhookLogQueue';
import './translations/config';
import { AxiosInterceptor } from './utils/ApiConfig';

const App = props => {
  const { page } = props;
  // switches betwwen different components like Onboard, Producteditions pased on Page prop
  const hoc = () => {
    switch (page) {
      case 'onboard':
        return <Onboard {...props} />;
      case 'budgetWriteback':
        return <GLWriteBack {...props} />;
      case 'glSettings':
        return <GLSettings {...props} />;
      case 'accountSetupStatus':
        return <AccountSetupStatus {...props} />;
      case 'webhookLogQueue':
        return <WebhookLogQueue />;
      case 'webhookAcctNotification':
        return <WebhookAcctNotification />;
      case 'automatedOnBoarding':
        return <AutomatedOnboarding {...props} />;
      case 'emptyEditor':
        return <EmptyEditor {...props} />;
      case 'forecastEditor':
        return <ForecastEditor {...props} />;
      case 'auditLog':
        return <AuditLog {...props} />;
      case 'jobs':
        return <Jobs {...props} />;
      case 'releaseNotes':
        return <ReleaseNotes {...props} />;
      case 'copyVersionSelectDate':
        return <CopyVersion {...props} />;
      case 'versionLocking':
        return <VersionLocking {...props} />;
      default:
        return <Fragment></Fragment>;
    }
  };
  return (
    <AxiosInterceptor props={props}>
      <div>{hoc()}</div>
    </AxiosInterceptor>
  );
};

export default App;
